export enum PurchaseOrderStatus {
    Pending,
    Approved,
    Rejected,
}

export interface PurchaseOrderLine {
    id: string;
    name: string;
    quantity: number;
    unitPrice: number;
    costPrice: number;
}

export interface PurchaseOrder {
    id: string;
    status: PurchaseOrderStatus;
    createdAt: Date;
    name: string;
    supplier: string;
    ourReference: string;
    deliveryDate: Date;
    companyName: string;
    deliveryAddress: string;
    postCode: string;
    estimateText: string;
    estimateTextExtended: string;
    lines: PurchaseOrderLine[];
}
